import http from "./http-common";
import GalleryModel from "../models/gallery";
import qs from "qs";

// Navbar APIs
// eslint-disable-next-line
export default new (class GalleryService {
  // Get all
  async getGalleryBySize({ page = 1, pageSize = 5, sort = "desc" }) {
    const query = qs.stringify(
      {
        sort: [`publishedAt:${sort}`],
        populate: "deep",
        pagination: {
          page: page,
          pageSize: pageSize,
        },
      },
      {
        encodeValuesOnly: true,
      }
    );
    return await http
      .get("/albums?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((gallery) => GalleryModel.get(gallery))
        );

        const meta = response.data.meta;

        return [data, meta];
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getGalleryBySlug(slug) {
    return await http
      .get(`/albums/?populate=deep`)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data
            .filter((i) => i.attributes.Slug === slug)
            .map((gallery) => GalleryModel.get(gallery))
        );

        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getAnotherGallery(slug) {
    return await http
      .get(
        `albums?sort[0]=publishedAt:desc&populate=deep&pagination[page]=1&pagination[pageSize]=3&filters[id][$ne]=${slug}`
      )
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((gallery) => GalleryModel.get(gallery))
        );

        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getGalleryByTag({ sort = "desc", tag = "" }) {
    const query = qs.stringify(
      {
        filters: {
          $and: [
            {
              tag: {
                tag: {
                  $eq: tag,
                },
              },
            },
          ],
        },
        sort: [`publishedAt:${sort}`],
        populate: "deep",
      },
      {
        encodeValuesOnly: true,
      }
    );
    return await http
      .get("/albums?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((gallery) => GalleryModel.get(gallery))
        );

        return [data];
      })
      .catch((error) => {
        console.log(error);
      });
  }
})();
